import React from "react";
import Field from "./Formfield";
import { ROLE_OPTIONS, ROLES_FOR_OPTIONS, MOBILE_COUNTRY_CODE_OPTIONS } from "./Tenantformoptions";
import "./TenantAdminTab.css";

/* ============================================================
   TENANT ADMIN TAB
   Props:
   - role: role state object (from AddTenant.js)
   - user: user state object (from AddTenant.js)
   - errors: flat error map from parent (keys like "user.email")
   - onRoleChange: parent's handleRoleChange(e)
   - onUserChange: parent's handleUserChange(e)
   - isEdit: whether the form is in edit mode (affects password field)
   ============================================================ */
const TenantAdminTab = ({ role, user, errors, onRoleChange, onUserChange, isEdit }) => {
  return (
    <div className="at-section">
      <h3 className="at-section__title">Tenant Admin</h3>
      <p className="at-section__subtitle">
        The role and first user account created for this tenant.
      </p>

      <h4 className="at-subheading">Role</h4>
      <div className="at-grid">
        <Field label="Role Code" required error={errors["role.code"]}>
          <input name="code" value={role.code} onChange={onRoleChange} placeholder="Admin" />
        </Field>

        <Field label="Role Name">
          <input name="name" value={role.name} onChange={onRoleChange} placeholder="Admin" />
        </Field>

        {/* <Field label="Applies To">
          <select name="roles_for" value={role.roles_for} onChange={onRoleChange}>
            {ROLES_FOR_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </Field> */}
      </div>

      <h4 className="at-subheading">Admin User</h4>
      <div className="at-grid">
        <Field label="Email" required error={errors["user.email"]}>
          <input type="email" name="email" value={user.email} onChange={onUserChange} placeholder="admin@acme.com" />
        </Field>

        <Field label="Role">
          <select name="role" value={user.role} onChange={onUserChange}>
            {ROLE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </Field>

        <div className="at-field-pair">
          <Field label="Country Code">
            <select name="mobile_country_code" value={user.mobile_country_code} onChange={onUserChange}>
              {MOBILE_COUNTRY_CODE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </Field>

          <Field label="Mobile Number" required error={errors["user.mobile_number"]}>
            <input name="mobile_number" value={user.mobile_number} onChange={onUserChange} placeholder="5551234567" />
          </Field>
        </div>

        <Field
          label="Password"
          required={!isEdit}
          error={errors["user.password"]}
          hint={isEdit ? "Leave blank to keep the current password" : undefined}
        >
          <input
            type="password"
            name="password"
            value={user.password}
            onChange={onUserChange}
            placeholder={isEdit ? "••••••••" : "Minimum 8 characters"}
          />
        </Field>
      </div>
    </div>
  );
};

export default TenantAdminTab;